<template>
    <b-modal id="bv-modal-example" hide-footer>
      <template #modal-title>Confirmation</template>

      <div class="row">
        <div class="col">
            <label class="form-label pt-0 mb-2" for="dealer-name">{{project.title}} - {{ formattedPrice(project.price) }}</label>
        </div>
      </div>

      <div class="row">
        <div class="col">
          {{project.description}}
        </div>
      </div>

<div class="row">
  <div class="col">
    <label class="form-label">State</label>
    <select class="form-select" v-model="state" @change="clearCity">
      <option value="0" disabled selected hidden>Choose a state</option>
      <option v-for="state in states" :value="state" :key="state">{{ state }}</option>
    </select>
  </div>

  <div class="col">
      <label class="form-label">City</label>
    <select class="form-select" v-model="city">
      <option v-if="!state" disabled>Choose a state first</option>
      <option v-for="city in cities[state]" :value="city" :key="city">{{ city }}</option>
    </select>
  </div>
    
  </div>

      <div class="row pt-3 pb-2">
        <div class="col">
        <button type="button" class="btn btn-dark submit col" @click="hideModal">Cancel</button>
        </div>
        <div class="col">
        <button type="button" class="btn btn-success submit col" @click="createProject(project)">Create project</button>
        </div>
      </div>

    </b-modal>
</template> 

<script>
export default {
  props: ['project'],

  data() {
    return {
      state: 0,
      city: 0,
      states: [],
      cities: []
    };
  },

  created() {
    this.getStates();
    this.getCities();
  },

  methods: {

    getStates() {
      axios
        .get('/get-states')
        .then((response) => {
          this.states = response.data;
        });
    },

    getCities() {
      axios
        .get('/get-cities')
        .then((response) => {
          this.cities = response.data;
        });
    },

    clearCity() {
      this.city = 0;
    },

    createProject(project) {
        if (this.state == 0) {this.sweetfire('Please choose a state for your leads')}
        else if (this.city == 0) {this.sweetfire('Please choose a city for your leads')}
        else {
        project.description = project.description + ' ' + this.city + ', ' + this.state+'.';
        this.$emit('create-project', project);
        this.hideModal();
        }
    },

    hideModal() {
      this.$bvModal.hide("bv-modal-example");
    },

    sweetfire(text) {
      Swal.fire({
        title: text,
        showConfirmButton: false,
        showDenyButton: false,
        showCancelButton: true,
        focusConfirm: false,
        cancelButtonText: "Ok",
        customClass: {
          title: "popup-title",
        },
      });
    },

  },

}
</script>


<style scoped>
select.form-select {
  background-color: #e9e9ed;
}
label.form-label {
  font-weight: 600 !important;
}

.btn.btn-success.submit, .btn.btn-dark.submit {
    border-radius: 5px !important;
}
</style>